<template>
  <div class="sdk-info-view"
       v-loading="loading">
    <article>
      <div class="cpl">
        <div class="cpl-header">
          <h2>上传SDK压缩包</h2>
        </div>
        <div class="cpl-body"
             style="border:none;">
          <upload-unit ref="sdkPkg"
                       url="/virus/sdk/upload"
                       :limitSize="20"
                       :limitType="limitType"
                       @uploadSuccess="uploadSuccess"
                       @uploadClear="uploadClear"
                       v-model="model"
                       tip="支持扩展名：.rar .zip">
          </upload-unit>
        </div>
      </div>
      <div class="cpl">
        <div class="cpl-header">
          <h2>填写SDK信息</h2>
        </div>
        <div class="cpl-body"
             style="padding-right: 128px;">
          <div class="gt-form">
            <div class="gt-form-item is-required">
              <label class="gt-form-item__label">SDK名称</label>
              <div class="gt-form-item__content"
                   :class="{'is-error':errors.has('name')}">
                <div class="gt-input">
                  <gt-input name="name"
                            placeholder="请输入SDK名称，不超过32个字符"
                            v-validate="'required|trim|max:32'"
                            v-model.trim="references.sdkName">
                  </gt-input>
                </div>
                <p class="gt-form-item__error"
                   v-show="errors.has('name')">{{ errors.first('name') }}</p>
              </div>
            </div>
            <div class="gt-form-item is-required">
              <label class="gt-form-item__label">SDK版本</label>
              <div class="gt-form-item__content">
                <div class="gt-input"
                     :class="{'is-error':errors.has('version')}">
                  <gt-input name="version"
                            placeholder="请输入SDK版本，不超过16个字符"
                            v-validate="'required|trim|max:16'"
                            v-model.trim="references.version">
                  </gt-input>
                </div>
                <p class="gt-form-item__error"
                   v-show="errors.has('version')">{{ errors.first('version') }}</p>
              </div>
            </div>
            <div class="gt-form-item is-required">
              <label class="gt-form-item__label">运行平台系统</label>
              <div class="gt-form-item__content">
                <div class="gt-input gt-select-input"
                     style="width: 100%;"
                     :class="{'is-error':errors.has('platform')}">
                  <gt-select v-model.trim="references.platform"
                             v-validate="'required'"
                             data-vv-validate-on="change"
                             name="platform"
                             style="width: 100%;"
                             placeholder="运行平台系统">
                    <gt-option v-for="item in platform"
                               :key="item.code"
                               :label="item.label"
                               :value="item.value">
                    </gt-option>
                  </gt-select>
                </div>
              </div>
            </div>
            <div class="gt-form-item is-required">
              <label class="gt-form-item__label">SDK服务行业</label>
              <div class="gt-form-item__content">
                <div id="service-trades"
                     class="gt-input gt-select-input"
                     style="width: 100%; position: relative;"
                     :class="{'is-error':errors.has('industrySelectList')}">
                  <gt-select multiple
                             v-model.trim="references.serviceTrades"
                             name="industrySelectList"
                             @change="validateIndustry"
                             v-validate="'required'"
                             style="width: 100%;"
                             placeholder="SDK服务行业">
                    <gt-option v-for="item in industryList"
                               :key="item.code"
                               :label="item"
                               :value="item">
                    </gt-option>
                  </gt-select>
                  <a href="javaScript:;"
                     class="custom-btn"
                     @click="open">自定义</a>
                  <!-- <div class="tag-row">
                    <gt-tag v-for="(tag, $index) in customTagList"
                            :key="$index"
                            @close="tagClose(tag)"
                            closable>
                      {{tag}}
                    </gt-tag>
                  </div> -->
                  <!-- <input class="gt-facker-input"
                         v-model="industrySelectList"
                         v-validate="'required'"
                         name="industrySelectList" /> -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </article>
    <custom-name ref="custom"
                 @customIndustry="customIndustry"></custom-name>
  </div>
</template>

<script>
import UploadUnit from './../upload_unit'
import CustomName from './custom'
import { getServiceTrades } from '@/api/sdk/index'
export default {
  name: 'SkdInfo',
  inject: ['sourceData'],
  components: {
    UploadUnit,
    CustomName
  },
  data () {
    let references = this.sourceData.sdk
    return {
      loading: true,
      industryList: [],
      tags: [],
      industrySelectList: [],
      customTagList: [],
      // serviceTrades: [...references.serviceTrades],
      platform: [{ label: 'Android', value: 0 }, { label: 'IOS', value: 1 }],
      references,
      model: { // 该对象用于规避报错，绑定的特殊处理
        id: references.id,
        name: references.name
      },
      limitType: ['zip', 'rar']
    }
  },
  methods: {
    init () {
      getServiceTrades({}).then(res => {
        this.loading = false
        let record = res.data.data.list
        this.industryList = [...record]
      })
    },
    customIndustry (value) {
      let include = this.references.serviceTrades.includes(value)
      if (!include) {
        this.references.serviceTrades.push(value)
        this.validateIndustry()
      }
    },
    // tagClose (vm) {
    //   let index = this.customTagList.findIndex(el => {
    //     return el === vm
    //   })
    //   this.customTagList.splice(index, 1)
    //   this.validateIndustry()
    // },
    open () {
      this.$refs.custom.dialogVisible = true
    },
    generateParams () {
      // this.references.name = this.model.name
      // this.references.serviceTrades = [...this.serviceTrades]
    },
    uploadSuccess (data) {
      this.references.id = data.id
      this.references.name = data.name
    },
    uploadClear (name) { // 其实不清除也没啥问题。。。
      this.references.name = ''
      this.references.id = ''
    },
    validateIndustry () {
      this.$validator.validate('industrySelectList')
    },
    validate () {
      return Promise.all([this.$validator.validateAll(), this.$refs.sdkPkg.validate()])
    }
  },
  created () {
    this.init()
  }
}
</script>

<style lang='less' scoped>
.upload-btn {
  width: 106px;
  height: 30px;
  font-size: 14px;
}
/* form */
.gt-form--inline .gt-form-item__label {
  width: 120px;
  text-align: left;
}
.gt-form-item__content {
  margin-left: 120px;
}
/deep/.gt-textarea__inner {
  padding-left: 10px;
}
/deep/.gt-checkbox__label {
  font-size: 14px;
}
.gt-select-input {
  width: 100%;
  margin-right: 10px;
  .gt-select {
    width: 120px;
  }
}
.custom-btn {
  position: absolute;
  white-space: nowrap;
  right: -60px;
  font-size: 14px;
  color: #4384bc;
  cursor: pointer;
}
.tag-row {
  margin-top: 10px;
  .gt-tag {
    margin-right: 10px;
    background-color: transparent;
    border: 1px solid #dddddd;
    border-radius: 4px;
    font-size: 14px;
    color: #333333;
    /deep/.gt-tag__close {
      color: #666b75;
      font-size: 10px;
      &:hover {
        background-color: transparent;
      }
    }
  }
}
.gt-facker-input {
  position: absolute;
  z-index: -10;
  opacity: 0;
}
</style>
